// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import VideoModalController from "./video_modal_controller"
application.register("video-modal", VideoModalController)

import InquiryFormController from "./inquiry_form_controller"
application.register("inquiry-form", InquiryFormController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import WechatModalController from "./wechat_modal_controller"
application.register("wechat-modal", WechatModalController)
